import { useSite, useSeo } from "@/context/SiteContext";
import { Section, ApartmentCard, CtaBanner, PageHero } from "@/components/public/Shared";
import { Users, ArrowRight } from "lucide-react";
import { Link, useT } from "@/i18n";

export default function Apartments() {
  const t = useT();
  const { apartments, content } = useSite();
  useSeo();
  return (
    <div data-testid="apartments-page">
      <PageHero eyebrow={t("Nos appartements")} title={t("Trois appartements indépendants, un même chalet")} text={t("Appartements 4, 6 et 8 personnes à Arvieux. Les trois peuvent être loués ensemble pour accueillir jusqu'à 18 personnes.")} image={content.hero?.image_url} testId="apartments-hero" />
      <Section className="bg-cream">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">{apartments.map((a) => <ApartmentCard key={a.id} apt={a} />)}</div>
        <div className="mt-14 card p-8 flex flex-col sm:flex-row items-start sm:items-center gap-5" data-testid="group-banner">
          <span className="w-14 h-14 rounded-full bg-sage-100 text-forest flex items-center justify-center shrink-0"><Users size={24} strokeWidth={1.5} /></span>
          <div className="flex-1"><h2 className="h3">{t("Séjour en groupe : jusqu'à {n} personnes", { n: apartments.reduce((s, a) => s + (Number(a.capacity) || 0), 0) || 18 })}</h2><p className="text-sm text-charcoal/70 mt-1">{t("Les 3 appartements peuvent être loués simultanément pour accueillir famille, amis ou groupes.")}</p></div>
          <Link to="/sejour-en-groupe" className="btn-primary" data-testid="group-request-cta">{t("Découvrir le séjour en groupe")} <ArrowRight size={16} /></Link>
        </div>
      </Section>
      <CtaBanner />
    </div>
  );
}
